import { render, staticRenderFns } from "./TheTaxSettings.vue?vue&type=template&id=ed0e321c&"
import script from "./TheTaxSettings.vue?vue&type=script&lang=js&"
export * from "./TheTaxSettings.vue?vue&type=script&lang=js&"
import style0 from "./TheTaxSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports